/* eslint-disable max-lines */
import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { func, oneOf, shape, string } from 'prop-types';
import NumberField from '../../atoms/inputField/NumberField';
import DropdownField from '../../atoms/inputField/DropdownField';
import { isAPhone, isNotEmpty } from '../../../utils/validator';
import territorySwitch from '../../territory/territorySwitch';
import { phoneCountries } from './phoneCountries';

const StyledDropdownWrapper = styled('div')(() => ({
  left: 0,
  bottom: 0,
  width: '92px',
  height: '100%'
}));

const StyledNumberField = styled(NumberField)(({ theme }) => ({
  borderRadius: `0 ${theme.radii[2]}px ${theme.radii[2]}px 0`
}));

const InputPhone = props => {
  const { value, state, onChange, name } = props;
  const prefixRef = useRef();
  const numberRef = useRef();
  let [focusInput, setFocusInput] = useState(''); // "let" because onBlur/onFocus can happen in the same "render"
  const focusOn = field => {
    setFocusInput(field);
    focusInput = field; // "unFocus" may be called by the other field in the same "render"
  };
  const unFocus = field => {
    if (focusInput === field) {
      setFocusInput('');
    }
  };
  const updateValue = newValue => onChange({ name, value: newValue });

  const currentPhoneCountry = phoneCountries.find(phoneCountry => phoneCountry.value === value?.country);
  const defaultPhoneNumber = value?.number?.replace(currentPhoneCountry?.label, '');

  return (
    <div data-labelizable={true} data-focus={focusInput !== ''} className="relative flex">
      <StyledDropdownWrapper>
        <DropdownField
          ref={prefixRef}
          options={phoneCountries}
          type="dropdown"
          name={name + '.country'}
          autoComplete="none"
          state={state}
          onChange={newValue => {
            updateValue({ country: newValue, number: numberRef.current.value });
            if (newValue) {
              numberRef.current.focus();
            }
          }}
          defaultValue={value && value.country}
          onFocus={() => focusOn('prefix')}
          onBlur={() => unFocus('prefix')}
        />
      </StyledDropdownWrapper>
      <div className="flex-1">
        <StyledNumberField
          ref={numberRef}
          name={name + '.number'}
          onChange={e => {
            updateValue({ country: prefixRef.current.value, number: e.target.value });
          }}
          state={state}
          defaultValue={value && value.number && defaultPhoneNumber}
          onFocus={() => focusOn('number')}
          onBlur={() => unFocus('number')}
        />
      </div>
    </div>
  );
};

InputPhone.defaultProps = {
  value: { country: territorySwitch({ io: 'BE', ch: 'CH', lu: 'LU' }) },
  onChange: () => null
};

InputPhone.propTypes = {
  onChange: func,
  name: string,
  value: shape({ country: string, number: string }),
  state: oneOf(['success', 'error', 'default'])
};

export default InputPhone;

export const isPhoneFilled = value => !!value && isNotEmpty(value.country) && isNotEmpty(value.number);
export const isPhoneNumberValid = value => !!value && isAPhone(value.number);
